module.exports = function() {
  return new Worker(__webpack_public_path__ + "6e6edfb05e4fd0631286.worker.js");
};